import React from "react";

import GridContainer from "../../mui-components/Grid/GridContainer";
import ItemGrid from "../../mui-components/Grid/GridItem";
import RegularCard from "../../mui-components/Card/RegularCard";
import MyPositionsTable from "../../containers/domain/my-position/MyPositionsTable";

const MyPositionsListingView = () => (
  <GridContainer>
    <ItemGrid xs={12}>
      <RegularCard
        title="Lista de Posições dos meus Clientes"
        content={<MyPositionsTable />}
      />
    </ItemGrid>
  </GridContainer>
);

export default MyPositionsListingView;
